import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3581636a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-admission" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "px-4 py-3 mt-6 bg-white border"
}
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm block ml-2 text-gray-400" }, "Загрузка данных поступления...", -1))
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col items-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-400" }, "При загрузке данных поступления произошла ошибка", -1))
const _hoisted_9 = { class: "create-admission__form" }
const _hoisted_10 = { class: "text-sm text-gray-400" }
const _hoisted_11 = {
  key: 0,
  class: "text-lg font-semibold mt-6"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "font-semibold" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_20 = { class: "create-admission__form" }
const _hoisted_21 = { class: "text-lg font-semibold" }
const _hoisted_22 = { class: "grid grid-cols-1 lg:grid-cols-4 gap-3 items-start" }
const _hoisted_23 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_24 = {
  key: 1,
  class: "fas fa-plus"
}
const _hoisted_25 = {
  key: 0,
  class: "flex items-center justify-between mt-2"
}
const _hoisted_26 = { class: "flex items-center justify-end mt-6" }
const _hoisted_27 = {
  key: 0,
  class: "font-semibold mr-6"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Редактирование поступления" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/tmc/admission')))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    (_ctx.admission_state.is_loading || _ctx.admission_state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.admission_state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_loader, { class: "primary small" }),
                _hoisted_6
              ]))
            : (_ctx.admission_state.is_failed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_the_button, {
                    class: "primary text small mt-2",
                    disabled: _ctx.admission_state.is_loading,
                    onClick: _ctx.loadAdmission
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Перезагрузить ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]))
              : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_9, [
            (!_ctx.isSecondMaterial)
              ? (_openBlock(), _createBlock(_component_the_select, {
                  key: 0,
                  disabled: _ctx.state.is_loading,
                  placeholder: "Поставщик",
                  "is-invalid": _ctx.state_validation.companyId.$error,
                  "validation-errors": _ctx.state_validation.companyId.$errors,
                  loading: _ctx.data_state.companies.is_loading,
                  failed: _ctx.data_state.companies.is_failed,
                  "error-text": "При получении списка поставщиков произошла ошибка",
                  options: _ctx.data_state.companies.list,
                  value: _ctx.state.companyId,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.companyId) = $event)),
                  "infinite-scroll": "",
                  onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
                  onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
                  onSearch: _ctx.searchCompanies,
                  onOptionBySearch: _ctx.unshiftFindedCompany,
                  class: "mt-4"
                }, null, 8, ["disabled", "is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]))
              : _createCommentVNode("", true),
            (!_ctx.isSecondMaterial)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 1,
                  disabled: _ctx.state.is_loading,
                  class: "mt-3",
                  placeholder: "Номер заявки JIRA",
                  value: _ctx.state.jiraNumber,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.jiraNumber) = $event)),
                  "is-invalid": _ctx.state_validation.jiraNumber.$error,
                  "validation-errors": _ctx.state_validation.jiraNumber.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]))
              : _createCommentVNode("", true),
            _createVNode(_component_the_select, {
              class: "mt-4",
              placeholder: "Склад",
              disabled: _ctx.state.is_loading,
              "is-invalid": _ctx.state_validation.warehouseId.$error,
              "validation-errors": _ctx.state_validation.warehouseId.$errors,
              loading: _ctx.data_state.warehouses.is_loading,
              failed: _ctx.data_state.warehouses.is_failed,
              "error-text": "При получении списка складов произошла ошибка",
              options: _ctx.data_state.warehouses.list,
              value: _ctx.state.warehouseId,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.warehouseId) = $event)),
              "search-by": "city",
              onRefresh: _ctx.loadWarehouses
            }, {
              "selected-option": _withCtx(({ option }) => [
                _createTextVNode(" Склад " + _toDisplayString(option.city), 1)
              ]),
              option: _withCtx(({ option }) => [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, "Склад " + _toDisplayString(option.city), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(option.full_address), 1)
                ])
              ]),
              _: 1
            }, 8, ["disabled", "is-invalid", "validation-errors", "loading", "failed", "options", "value", "onRefresh"]),
            (!_ctx.isSecondMaterial)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 2,
                  disabled: _ctx.state.is_loading,
                  class: "mt-3",
                  placeholder: "Номер доверенности",
                  value: _ctx.state.warrantNumber,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.warrantNumber) = $event)),
                  "is-invalid": _ctx.state_validation.warrantNumber.$error,
                  "validation-errors": _ctx.state_validation.warrantNumber.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]))
              : _createCommentVNode("", true),
            (_ctx.isSecondMaterial)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 3,
                  disabled: _ctx.state.is_loading,
                  class: "mt-3",
                  placeholder: "Кол-во разобранных паллет",
                  value: _ctx.state.palletAmount,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.palletAmount) = $event)),
                  "is-invalid": _ctx.state_validation.palletAmount.$error,
                  "validation-errors": _ctx.state_validation.palletAmount.$errors
                }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]))
              : _createCommentVNode("", true)
          ]),
          (Boolean(_ctx.state.items.length))
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Товары (" + _toDisplayString(_ctx.state.items.length) + ") ", 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.items, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "px-4 py-3 mt-3 bg-white border flex items-center justify-between",
              key: `item-${i}`
            }, [
              (_ctx.isSecondMaterial)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(item.tmc_name), 1),
                    _createElementVNode("p", null, "количество: " + _toDisplayString(item.amount), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(item.tmc_name), 1),
                    _createElementVNode("p", null, " количество: " + _toDisplayString(item.amount) + ", цена за единицу: " + _toDisplayString(item.unitPrice) + ", стоимость: " + _toDisplayString(_ctx.roundTo(item.amount * item.unitPrice)) + " тг. ", 1),
                    (item.isNds)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, "с НДС"))
                      : _createCommentVNode("", true)
                  ])),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_the_button, {
                  disabled: _ctx.state.is_loading,
                  class: "yellow text small mr-3",
                  onClick: ($event: any) => (_ctx.startEditItem(i))
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]),
                _createVNode(_component_the_button, {
                  disabled: _ctx.state.is_loading,
                  loading: _ctx.state.is_item_removing,
                  class: "red text small",
                  onClick: ($event: any) => (_ctx.removeItem(i))
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 2
                }, 1032, ["disabled", "loading", "onClick"])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("p", _hoisted_21, [
              (_ctx.item_state.is_edit)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Редактирование товара")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Добавление товара")
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_the_select, {
                class: "mt-2",
                disabled: _ctx.state.is_loading,
                placeholder: "ТМЦ",
                "is-invalid": _ctx.item_validation.tmc.$error,
                "validation-errors": _ctx.item_validation.tmc.$errors,
                loading: _ctx.data_state.tmc.is_loading,
                failed: _ctx.data_state.tmc.is_failed,
                "error-text": "При получении списка ТМЦ произошла ошибка",
                options: _ctx.data_state.tmc.list,
                value: _ctx.item_state.tmc,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item_state.tmc) = $event)),
                "infinite-scroll": "",
                "search-by": "name",
                onChange: _ctx.onTmcChange,
                onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadTMC(_ctx.data_state.tmc.pagination.current_page))),
                onLoadmore: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadMoreTMC(_ctx.data_state.tmc.pagination.current_page + 1))),
                onSearch: _ctx.searchTMC,
                onOptionBySearch: _ctx.unshiftFindedTMC
              }, null, 8, ["disabled", "is-invalid", "validation-errors", "loading", "failed", "options", "value", "onChange", "onSearch", "onOptionBySearch"]),
              (_ctx.isClient)
                ? (_openBlock(), _createBlock(_component_the_select, {
                    key: 0,
                    placeholder: "Клиент",
                    loading: _ctx.data_state.companies.is_loading,
                    failed: _ctx.data_state.companies.is_failed,
                    "error-text": "При получении списка клиентов произошла ошибка",
                    "is-invalid": _ctx.item_validation.companyId.$error,
                    "validation-errors": _ctx.item_validation.companyId.$errors,
                    options: _ctx.data_state.companies.list,
                    value: _ctx.item_state.companyId,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item_state.companyId) = $event)),
                    "infinite-scroll": "",
                    "search-without-refresh": "",
                    onRefresh: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadItemCompanies(1))),
                    class: "mt-2"
                  }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value"]))
                : _createCommentVNode("", true),
              _createVNode(_component_the_input, {
                disabled: _ctx.state.is_loading,
                "is-invalid": _ctx.item_validation.amount.$error,
                "validation-errors": _ctx.item_validation.amount.$errors,
                placeholder: "Количество",
                value: _ctx.item_state.amount,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.item_state.amount) = $event))
              }, null, 8, ["disabled", "is-invalid", "validation-errors", "value"]),
              (!_ctx.isSecondMaterial)
                ? (_openBlock(), _createBlock(_component_the_input, {
                    key: 1,
                    disabled: _ctx.state.is_loading,
                    "is-invalid": _ctx.item_validation.unitPrice.$error,
                    "validation-errors": _ctx.item_validation.unitPrice.$errors,
                    placeholder: "Цена за единицу",
                    value: _ctx.item_state.unitPrice,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item_state.unitPrice) = $event))
                  }, null, 8, ["disabled", "is-invalid", "validation-errors", "value"]))
                : _createCommentVNode("", true),
              _createVNode(_component_the_button, {
                class: "primary text small mt-2 py-3",
                disabled: _ctx.state.is_loading,
                onClick: _ctx.addItem
              }, {
                default: _withCtx(() => [
                  (_ctx.item_state.is_edit)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                    : (_openBlock(), _createElementBlock("i", _hoisted_24))
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            (!_ctx.isSecondMaterial)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_checkbox, {
                    label: "с НДС",
                    disabled: _ctx.state.is_loading,
                    value: _ctx.item_state.isNds,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.item_state.isNds) = $event))
                  }, null, 8, ["disabled", "value"]),
                  _createElementVNode("span", null, "Стоимость: " + _toDisplayString(_ctx.roundTo(_ctx.itemCost)) + " тг.", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            (!_ctx.isSecondMaterial)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, " Итого: " + _toDisplayString(_ctx.roundTo(_ctx.totalItemsCost)) + " тг. ", 1))
              : _createCommentVNode("", true),
            _createVNode(_component_the_button, {
              class: "primary small",
              loading: _ctx.state.is_loading,
              onClick: _ctx.submitForm
            }, {
              default: _withCtx(() => [
                _hoisted_28,
                _createTextVNode(" Сохранить заявку на поступление ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ], 64))
  ]))
}